import {

  Component,

  HostListener

} from '@angular/core';
 
import { COMPANY_DATA } from '../../data/company.data';
 
@Component({

  selector: 'app-header',

  standalone: true,

  templateUrl: './header.component.html',

  styleUrl: './header.component.scss'

})

export class HeaderComponent {
 
  company = COMPANY_DATA.company;
 
  navigation = COMPANY_DATA.navigation;
 
  socialLinks = COMPANY_DATA.socialLinks;
 
  menuOpen = false;
 
  scrolled = false;
 
 
  @HostListener('window:scroll')

  onWindowScroll(): void {
 
    this.scrolled = window.scrollY > 20;
 
  }
 
 
  toggleMenu(): void {
 
    this.menuOpen = !this.menuOpen;
 
  }
 
 
  closeMenu(): void {
 
    this.menuOpen = false;
 
  }
 
}
 